import { render, staticRenderFns } from "./twoAdd.vue?vue&type=template&id=d00e803c&scoped=true"
import script from "./twoAdd.vue?vue&type=script&lang=js"
export * from "./twoAdd.vue?vue&type=script&lang=js"
import style0 from "./twoAdd.vue?vue&type=style&index=0&id=d00e803c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00e803c",
  null
  
)

export default component.exports